import dayjs from 'dayjs';
import 'dayjs/locale/es';

const formatDateFilter = (stringDate: string | undefined, format: string) => {
  let result = '';
  if (stringDate) {
    const dayjsInstance = dayjs(stringDate, { locale: 'es' }).subtract(1, 'hour');
    if (dayjsInstance.isValid()) {
      result = dayjsInstance.format(format);
    }
  }
  return result;
};

export default formatDateFilter;
